import React, { memo } from 'react';
import { Order } from '../../types/order';
import { FavoriteOrder } from '../../services/favoriteService';
import UserOrderDetailModal from './UserOrderDetailModal';

interface UserOrdersModalsProps {
  // Order Modal
  selectedOrder: Order | null;
  onCloseOrderModal: () => void;

  // Favorite Modal
  selectedFavorite: FavoriteOrder | null;
  onCloseFavoriteModal: () => void;

  // Shared props
  favoriteIds: Set<number>;
  onReorder: (order: Order) => void;
  onFavoriteToggle: (orderId: number) => void;
  onFavoriteModalReorder: (order: Order) => void;
}

export const UserOrdersModals = memo<UserOrdersModalsProps>(
  ({
    // Order Modal
    selectedOrder,
    onCloseOrderModal,

    // Favorite Modal
    selectedFavorite,
    onCloseFavoriteModal,

    // Shared props
    favoriteIds,
    onReorder,
    onFavoriteToggle,
    onFavoriteModalReorder,
  }) => {
    return (
      <>
        {/* Sipariş Detay Modalı */}
        <UserOrderDetailModal
          selectedOrder={selectedOrder}
          favorites={favoriteIds}
          onClose={onCloseOrderModal}
          onReorder={onReorder}
          onFavoriteToggle={onFavoriteToggle}
        />

        {/* Favori Sipariş Detay Modalı */}
        <UserOrderDetailModal
          selectedOrder={
            selectedFavorite
              ? {
                  id: selectedFavorite.order_id,
                  user_id: selectedFavorite.user_id,
                  user_name: selectedFavorite.user_name,
                  user_surname: selectedFavorite.user_surname,
                  management: selectedFavorite.management,
                  office: selectedFavorite.office,
                  total_amount: selectedFavorite.total_amount,
                  status: selectedFavorite.status,
                  ticket_used: selectedFavorite.ticket_used,
                  created_at: selectedFavorite.order_created_at,
                  updated_at: selectedFavorite.order_updated_at,
                }
              : null
          }
          favorites={favoriteIds}
          onClose={onCloseFavoriteModal}
          onReorder={onFavoriteModalReorder}
          onFavoriteToggle={onFavoriteToggle}
        />
      </>
    );
  }
);

UserOrdersModals.displayName = 'UserOrdersModals';
